import { Page } from 'types';
import fetchWithRetry from './fetch-retry';

export const fetchPaginated =
  <T>(endpoint: string, additionalParams?: { [key: string]: boolean | string | number }) =>
  async (params: {
    pageNum?: number;
    pageSize?: number;
    from?: Date;
    to?: Date;
    sortField?: string;
    sortDirection?: string;
    filterString?: string;
  }): Promise<Page<T>> => {
    const url = new URL('/api/' + endpoint, window.location.origin);

    url.searchParams.append('pageNum', `${params.pageNum ?? 0}`);
    url.searchParams.append('pageSize', `${params.pageSize ?? 100}`);
    if (params.sortField) url.searchParams.append('sortField', params.sortField);
    if (params.sortDirection) url.searchParams.append('sortDirection', params.sortDirection);
    if (params.filterString) url.searchParams.append('filterString', params.filterString);
    if (additionalParams) {
      Object.entries(additionalParams).forEach(([key, val]) => url.searchParams.append(key, `${val}`));
    }

    return await fetchWithRetry(url, { method: 'GET' }, {});
  };
